import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";

function OnHandPreviewModal(props) {
    const { modal, setModal, updateOrderDetails } = props;
    const [productId, setProductId] = useState(props.productId);
    const [orderDetailsObj, setOrderDetailsObj] = useState(props.orderDetailsObj);
    const [orderDetailItems, setOrderDetailItems] = useState(orderDetailsObj[productId]);
    const [totalQty, setTotalQty] = useState(0);
    const [disabledPrev, setDisabledPrev] = useState(false);
    const [disabledNext, setDisabledNext] = useState(false);
    const keys = Object.keys(orderDetailsObj);

    useEffect(() => {
        if (keys?.length > 0) {
            let index = Object.keys(orderDetailsObj).indexOf(`${productId}`);
            if (index === keys.length - 1) {
                setDisabledNext(true);
            }
            else if (index === 0) {
                setDisabledPrev(true)
            }
            updateTotalQty(orderDetailsObj[productId]);
        }
    }, [])

    const handlePrev = () => {
        let index = Object.keys(orderDetailsObj).indexOf(`${productId}`);
        let previousIndex = index - 1;
        let ProductID = keys[previousIndex];
        if (previousIndex === 0) {
            setDisabledPrev(true);
        }
        setDisabledNext(false);
        setProductId(ProductID);
        updateTotalQty(orderDetailsObj[ProductID]);
        setOrderDetailItems(orderDetailsObj[ProductID])
    }

    const handleNext = () => {
        let index = Object.keys(orderDetailsObj).indexOf(`${productId}`);
        let nextIndex = index + 1;
        let ProductID = keys[nextIndex];
        if (nextIndex === keys.length - 1) {
            setDisabledNext(true);
        }
        setDisabledPrev(false)
        setProductId(ProductID);
        updateTotalQty(orderDetailsObj[ProductID]);
        setOrderDetailItems(orderDetailsObj[ProductID])
    }

    const updateQty = (value, odid) => {
        setOrderDetailsObj(prev => ({
            ...prev,
            [productId]: prev[productId].map(item =>
                item.ODID === odid ? { ...item, Qty: value } : item
            )
        }));
        setOrderDetailItems(prev =>
            prev.map(item =>
                item.ODID === odid ? { ...item, Qty: value } : item
            )
        );
    }

    const updateTotalQty = (orderItems) => {
        let totalQty = 0;
        orderItems?.map(item => totalQty += parseFloat(item.Qty));
        setTotalQty(totalQty);
    }

    return ReactDOM.createPortal(
        <React.Fragment>
            <div
                className={"modal fade " + (modal ? "show " : "")}
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={modal ? { display: "block" } : { display: "none" }}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-primary p-2 px-3">
                            <h1
                                className="modal-title fs-16 text-white"
                                id="exampleModalLabel"
                            >
                                On Hand Changes
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{
                                    backgroundImage: `url(${closeImg})`,
                                    opacity: 1,
                                    padding: "16px",
                                }}
                                onClick={() => setModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form action="#">

                                <div className="card-table table-responsive position-relative">
                                    <table className="table table-form mb-0">
                                        <thead>
                                            <tr>
                                                <td scope="col" className="width-lg-1">Buyer Code</td>
                                                <td scope="col" className="width-lg-10">Product Name</td>
                                                <td scope="col" className="width-lg-6">Units</td>
                                                <td scope="col" className="width-lg-1">Qty</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderDetailItems?.map((orderDetailItem, index) => {
                                                return (
                                                    <tr key={`${orderDetailItem.ProductID}${index}`} className="custom-space">
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm input-width-100"
                                                                placeholder="Product Name"
                                                                value={orderDetailItem.tblOrder.tblCustomer.BuyerCode}
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm input-width-100"
                                                                placeholder="Product Name"
                                                                value={`${orderDetailItem.ProductName} ${orderDetailItem.ClassName || ""} ${orderDetailItem.SizeName || ""} `}
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm input-width-100"
                                                                placeholder="Unit"
                                                                value={orderDetailItem.tblUnit.UnitName}
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control input-sm input-width-100"
                                                                placeholder="Qty"
                                                                value={orderDetailItem.Qty}
                                                                onChange={(e) => updateQty(e.target.value, orderDetailItem.ODID)}
                                                                onBlur={() => updateTotalQty(orderDetailsObj[productId])}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                            </form>
                            <div className="d-flex justify-content-end">
                                <input
                                    type="text"
                                    className="form-control input-sm width-lg-13"
                                    placeholder="Total Qty"
                                    value={totalQty}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="col d-flex justify-content-end align-items-end">
                                <button
                                    onClick={handlePrev}
                                    className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    disabled={disabledPrev}
                                >
                                    Previous
                                </button>
                                <button
                                    onClick={handleNext}
                                    className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    disabled={disabledNext}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => updateOrderDetails(orderDetailsObj)}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    Save
                                </button>
                                <button
                                    onClick={() => setModal(false)}
                                    className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                                >
                                    Exit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal ? <div className="modal-backdrop fade show" /> : ""}
        </React.Fragment>,
        document.getElementById("modal-root")
    );
}
export default OnHandPreviewModal;